export function transformID(id) {
  //return id.replace(/\s/g, '_');
  return id.replace('_', ' ');
}

export default {
  transformID
};



// WEBPACK FOOTER //
// ./src/javascripts/lib/seatmaps/levelBASelectorHelper.js